import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Login from "./Components/Pages/Login";
import WaitingScreen from "./Components/Pages/WaitingScreen";
import AppContainer from "./Components/Containers/AppContainer";
import Home from "./Components/Pages/Home";
import Profile from "./Components/Pages/Profile";
import LastAppointments from "./Components/Pages/LastAppointments";
import RoomsMonitoring from "./Components/Pages/Room/RoomsMonitoring";
import RoomHistory from "./Components/Pages/Room/RoomHistory";
import Statistics from "./Components/Pages/Statistics";
import UploadVideo from "./Components/Pages/Video/UploadVideo";
import ManagementVideo from "./Components/Pages/Video/ManagementVideo";
import AllVideo from "./Components/Pages/Video/AllVideo";
import EditVideo from "./Components/Pages/Video/EditVideo";
import AttribVideo from "./Components/Pages/Video/AttribVideo";
import Signup from "./Components/Pages/CreateUser";
import UserManagement from "./Components/Pages/UserManagement";
import StatisticsBeta from "./Components/Pages/StatisticsBeta";
import RecentComments from "./Components/Pages/random";
import UpdateOldDocuments from "./Components/Pages/DeleteOldFolders";

export default function Routes() {
  // Synchroniser laboratory et currentLab uniquement lors de la connexion initiale
  useEffect(() => {
    const laboratory = localStorage.getItem("laboratory");
    const currentLab = localStorage.getItem("currentLab");

    // On s'assure que currentLab est défini si laboratory existe
    // mais uniquement si l'utilisateur vient de se connecter (pas de currentLab défini)
    if (laboratory && !currentLab) {
      localStorage.setItem("currentLab", laboratory);
    }

    // On ne fait plus la synchronisation forcée qui empêchait le changement de laboratoire
  }, []);

  return (
    <Router>
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        {!localStorage.laboratory && <Redirect push to="/login" />}
        <Route path="/waitingScreen">
          <WaitingScreen />
        </Route>
        <AppContainer>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/roomsMonitoring">
            <RoomsMonitoring />
          </Route>

          <Route path="/roomHistory">
            <RoomHistory />
          </Route>
          <Route path="/lastAppointments">
            <LastAppointments />
          </Route>
          <Route path="/statistics">
            <Statistics />
          </Route>
          <Route path="/uploadVideo">
            <UploadVideo />
          </Route>
          <Route path="/managementVideo">
            <ManagementVideo />
          </Route>
          <Route path="/editVideo">
            <EditVideo />
          </Route>
          <Route path="/userProfile">
            <Profile />
          </Route>
          <Route path="/allvideo">
            <AllVideo />
          </Route>
          <Route path="/attribVideo">
            <AttribVideo />
          </Route>
          <Route path="/createuser">
            <Signup />
          </Route>
          <Route path="/usersmanagment">
            <UpdateOldDocuments />
          </Route>
            <Route path="/random">
            <RecentComments></RecentComments>
          </Route>
          

          <Route path="/statisticsBeta">
            <StatisticsBeta />
          </Route>
        </AppContainer>
      </Switch>
    </Router>
  );
}
